export default "__VITE_ASSET__C5tZpn_m__"